<template>
  <div class="upload-file">
    <el-upload
        multiple
        :action="uploadFileUrl"
        :before-upload="handleBeforeUpload"
        :limit="limit"
        accept=".pdf,.ofd"
        :file-list="fileList"
        :on-error="handleUploadError"
        :on-exceed="handleExceed"
        :headers="headers"
        :on-success="handleUploadSuccess"
        :show-file-list="false"
        class="upload-file-uploader"
        ref="fileUpload"
    >
      <!-- 上传按钮 -->
      <el-button type="primary" icon="el-icon-folder-opened" size="small">上传待验证的 PDF 或 OFD 文件</el-button>

    </el-upload>

  </div>
</template>

<script>
import axios from 'axios'
import {auth} from "@/utils/auth";

export default {
  name: "FileUpload",
  props: {
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: 1,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["ofd", "pdf"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    // 是否显示提示
    loading: {
      type: Boolean,
      default: true
    },
    //  文件id
    filesCacheId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      uploadFileUrl: process.env.VUE_APP_API_BASE_URL + "/api/v1/online/verifySign", // 上传文件服务器地址
      headers: {
        // 'Authorization': auth.getToken(),
      },
      fileList: [],
      fileDate: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          let temp = 1;
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',');
          // 然后将数组转为对象数组
          this.fileList = list.map(item => {
            if (typeof item === "string") {
              item = {name: item, url: item};
            }
            item.uid = item.uid || new Date().getTime() + temp++;
            return item;
          });
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      this.$emit('update:loading', true)
      // 校检文件类型
      if (this.fileType) {
        const fileName = file.name.split('.');
        const fileExt = fileName[fileName.length - 1];
        const isTypeOk = this.fileType.indexOf(fileExt) >= 0;
        if (!isTypeOk) {
          this.$emit('update:loading', false)
          this.$message.error(`文件格式不正确，请上传${this.fileType.join("/")}格式文件!`);
          return false;
        }
      }
      // 校检文件名是否包含特殊字符
      if (file.name.includes(',')) {
        this.$emit('update:loading', false)
        this.$message.error('文件名不正确，不能包含英文逗号!');
        return false;
      }
      // 校检文件大小
      // if (this.fileSize) {
      //   const isLt = file.size / 1024 / 1024 < this.fileSize;
      //   if (!isLt) {
      //     this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
      //     return false;
      //   }
      // }
      // this.$modal.loading("正在上传文件，请稍候...");
      this.number++;
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$emit('update:loading', false)
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError(err) {
      console.log(err)
      this.$emit('update:loading', false)
      this.$message.error("上传文件失败，请重试");
    },
    // 上传成功回调
    handleUploadSuccess(res) {
      console.log(res)
      if (res.code === 200) {
        let resultList = res.data
        if (res.data.signedInfo && res.data.result == 'true') {
          resultList.msg = '验证成功，文件未被篡改，识别到' + res.data.signedInfo.length + '枚电子签记录'
        }
        this.$emit('update:resultList', res.data);
        this.$emit('update:loading', false)
      } else {
      }

      this.fileList = []
    },
    // 删除文件
    handleDelete(index) {
      this.fileList.splice(index, 1);
      this.$emit("input", this.listToString(this.fileList));
    },
    // 上传结束处理
    uploadedSuccessfully() {
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList);
        this.uploadList = [];
        this.number = 0;
        this.$emit("input", this.listToString(this.fileList));
        // this.$modal.closeLoading();
      }
    },
    // 获取文件名称
    getFileName(name) {
      // 如果是url那么取最后的名字 如果不是直接返回
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1);
      } else {
        return name;
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : '';
    }
  }
};
</script>

<style scoped lang="less">
.upload-file-uploader {
  margin-bottom: 5px;
}

.upload-file-list .el-upload-list__item {
  border: 1px solid #e4e7ed;
  line-height: 2;
  margin-bottom: 10px;
  position: relative;
}

.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}

.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}
</style>
